import React from "react";
import Image from "next/image";
import { cn } from "../../../lib/utils";

interface OptionThumbnailProps {
  option: any;
  className?: string;
  width?: number;
  height?: number;
  sizes?: string;
}

export const OptionThumbnail: React.FC<OptionThumbnailProps> = ({
  option,
  className,
  width = 350,
  height = 197,
  sizes = "(max-width: 768px) 50vw, (max-width: 1200px) 33vw, 25vw",
}) => {
  if (option?.metadata?.thumbnail) {
    return (
      <Image
        className={cn("object-cover object-center h-full w-full", className)}
        src={option.metadata.thumbnail}
        width={width}
        height={height}
        alt={option.id}
        sizes={sizes}
      />
    );
  }

  if (option?.metadata?.uiColor) {
    return (
      <div
        className={cn("w-full h-full", className)}
        style={{
          backgroundColor: option.metadata.uiColor,
        }}
      />
    );
  }

  return (
    <Image
      className={cn("object-cover object-center h-full w-full", className)}
      src="/images/placeholder.svg"
      width={width}
      height={height}
      alt={option.id}
      sizes={sizes}
    />
  );
};
